import { useState, useEffect } from "react";
// import { useAuth } from "../hooks/useAuth";
import useAuth from "../hooks/useAuth";
import Input from "./FormElements/Input"; // Import du composant Input
import Loader from "./Loader";
import config from '../config.js';
import { callAPI } from '../hooks/CallAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const LoginForm = () => {
    const [user_login, setUserLogin] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false); // État pour la visibilité du mot de passe
    const { login } = useAuth();

    const [listAccounts, setListAccounts] = useState([]);

    // Utiliser useEffect pour appeler l'API lors du chargement du composant
    useEffect(() => {
        const fetchAccounts = async () => {

            if (config.getEnv() === 'dev') {
                try {
                    const response = await callAPI('/get-accounts', { password: btoa('sisoem00014') });
                    setListAccounts(response.datas)
                } catch (error) {
                    console.error("Erreur lors de l'appel API:", error);
                }
            }
        };

        fetchAccounts();
    }, []);


    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Démarre le chargement

        try {
           await login(user_login, password);

        } catch (error) {
            console.error('Erreur de connexion:', error);
            // Ici, vous pouvez également gérer l'affichage des messages d'erreur.
        } finally {
            setIsLoading(false); // Arrête le chargement indépendamment du résultat
        }
    };

    const debug = (name, object) => {
        var output = '';
        for (var property in object) {
            output += property + ': ' + object[property] + '; ';
        }
        // console.log(output);
        return "Contenu de la variable " + name + " : " + output;
    }

    return (
        <div className="flex flex-col w-full jutify-center">
            <div className="header bg-mgray text-mdark py-8 px-10 text-center ">
                <h1 className="text-xl sm:text-4xl font-extrabold text-mlime mb-4 uppercase">Connexion</h1>
                <p className="text-lg font-bold text-custom-color">Bienvenue dans votre espace client</p>
            </div>
         
            {!isLoading ?
                <div className="container mx-auto px-10 py-10">
                    <form id="loginForm" className="m-10 w-full max-w-md mx-auto" onSubmit={handleLogin}>
                        <Input
                            name="user_login"
                            label="Votre identifiant de connexion"
                            value={user_login}
                            onChange={(e) => setUserLogin(e.target.value)}
                        />

                        <div className="relative">
                            <Input
                                name="password"
                                label="Votre mot de passe"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type={showPassword ? "text" : "password"} 
                            />

                            <button
                                type="button"
                                className="absolute inset-y-0 right-0 px-3 flex items-center"
                                onClick={() => setShowPassword(!showPassword)} 
                                style={{ width: "40px", justifyContent: "center" }}
                            >
                                {showPassword ? <FontAwesomeIcon icon="fa-regular fa-eye" /> : <FontAwesomeIcon icon="fa-regular fa-eye-slash" />}
                            </button>
                        </div>

                        <div className="text-center py-4">
                            <p>Mot de passe oublié ? <Link to="/reset-password" className="underline font-semibold">Réinitialisez-le ici</Link>
                            </p>
                        </div>

                        <button type="submit" className="bg-mlime mt-10 font-bold rounded-3xl text-white py-3 px-4 block w-full duration-500 hover:bg-colorbutton">Se connecter</button>
                    </form>

                    {config.getEnv() === 'dev' && listAccounts.length > 0 && (
                        <div className="p-5 list-accounts border border-orange-500 bg-orange-100  lg:w-2/3 lg:mx-auto rounded-lg shadow-md">
                            <h5 className="text-lg font-bold mb-4">Liste des comptes</h5>
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-500">
                                    <thead className="">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entreprise</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Login</th>
                                        </tr>
                                    </thead>
                                    <tbody className=" divide-y divide-gray-300">
                                    {listAccounts.map((acc, index) => (
                                            <tr key={acc.id || `${acc.user_login}-${index}`}>
                                                <td className="px-6 py-1 ">{acc.raison_sociale}</td>
                                                <td className="px-6 py-1 whitespace-nowrap">{acc.user_login}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                : <div className="flex justify-center items-center grow">
                    <Loader firstColor="mlime" size="50" />
                </div>
            }

        </div>
    );
};